import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class ApplicationService extends ApiService {
  public getApplications(options) {
    return this.call(new ApiGetOptions(
      {
        url: '/applications',
        params: options,
      },
    ));
  }

  public show(applicationId, options = {}) {
    return this.call(new ApiGetOptions(
      {
        url: `/applications/${applicationId}`,
        params: options,
      },
    ));
  }

  public getPendingApplications(options) {
    return this.call(new ApiGetOptions(
      {
        url: '/applications/pending',
        params: options,
      },
    ));
  }

  public approve(applicationId, options = {}) {
    return this.call(new ApiPostOptions(
      {
        url: `/applications/${applicationId}/approval`,
        data: decamelizeKeysDeep(options),
      },
    ));
  }

  public reject(applicationId, options = {}) {
    return this.call(new ApiPostOptions(
      {
        url: `/applications/${applicationId}/rejection`,
        data: decamelizeKeysDeep(options),
      },
    ));
  }

  public disable(applicationId, options = {}) {
    return this.call(new ApiPostOptions(
      {
        url: `/applications/${applicationId}/disable`,
        data: decamelizeKeysDeep(options),
      },
    ));
  }

  public enable(applicationId, options = {}) {
    return this.call(new ApiPostOptions(
      {
        url: `/applications/${applicationId}/enable`,
        data: decamelizeKeysDeep(options),
      },
    ));
  }
}
